import UmsLogicSdk, { PERMISSIONS_CHECK_STRATEGY } from './src/UmsLogicSdk';

export { PERMISSIONS_CHECK_STRATEGY };
export default UmsLogicSdk;
